import IService from "./service";

const PERSISTENT_STORAGE_KEY = 'navigation.next';

export default class RouterService extends IService {
    /**
     * Getter
     * @returns {Storage}
     */
    get storage() {
        return this.config.storage;
    }

    /**
     * Getter
     * @returns {Route}
     */
    get index() {
        return {name: 'Dashboard'};
    }

    /**
     * Getter
     * @returns {Route}
     */
    get login() {
        return {name: 'Login'};
    }

    /**
     * Getter
     * @returns {Route}
     */
    get logout() {
        return {name: 'Logout'};
    }

    /**
     * Get saved next route
     * @returns {Route}
     */
    get next() {
        const json = this.storage.getItem(PERSISTENT_STORAGE_KEY);
        return json ? JSON.parse(json) : null;
    }

    /**
     * Set saved next route
     * @param route {Route|boolean|null}
     */
    set next(route) {
        if (route) {
            this.storage.setItem(PERSISTENT_STORAGE_KEY, this.serialize(route));
        } else {
            this.storage.removeItem(PERSISTENT_STORAGE_KEY);
        }
    }

    /**
     * Serialize route object
     * @param route {Route}
     * @returns {string}
     */
    serialize(route) {
        const whitelist = [
            'path',
            'hash',
            'meta',
            'name',
            'params',
            'query',
        ];
        const result = Object.keys(route).reduce(
            (result, key) => {
                if (whitelist.indexOf(key) !== -1) {
                    result[key] = route[key];
                }
                return result;
            },
            {}
        );
        return JSON.stringify(result);
    }

    /**
     * Remove saved next route
     */
    reset() {
        this.next = null;
    }
}